var AuthenticationError;
(function (AuthenticationError) {
    AuthenticationError["NonexistentEmail"] = "AADB2C90157";
    AuthenticationError["ForgotPassword"] = "AADB2C90118";
})(AuthenticationError || (AuthenticationError = {}));
export default AuthenticationError;
